import axios from "axios";
import { BaseUrl } from "./apiEndPoints";



const callApi = (url, method, payload ,token,API_BASE) => {
    return new Promise(async (resolve, reject) => {
        const userDetails = JSON.parse(sessionStorage.getItem("userDetails"))||{}   
        let config = payload ? {
            method: method,
            url: url,
            baseURL: `${API_BASE ||BaseUrl}`,
            headers: {
                // 'Content-Type': payload ? 'application/json' : undefined,
                "X-Company-ID":userDetails?.company_id,
                "Authorization":`Bearer ${token}`,
            },
            data: payload
        }:{
            method: method,
            url: url,
            baseURL: `${API_BASE||BaseUrl}`,
            headers: {
                // 'Content-Type': payload ? 'application/json' : undefined,
                "X-Company-ID":userDetails?.company_id,
                "Authorization":`Bearer ${token}`,
            },  
        }
        try {
            
            // //console.log(config);
            const response = await axios(config)
            if (response.status < 400 ) {
                resolve(response.data)
            }
            else{
                reject(response)
            }
        }
        catch (error) {
            reject(error)
        }
    })
}


export { callApi }